/**
 * English (en-GB) translations for ITSH Control Panel
 * All user-facing text strings are centralized here.
 */

import {
  common,
  help,
  keyboard,
  password,
  notifications,
  breadcrumbs,
  quickActions,
  globalSearch,
  ticket,
  a11y,
  validation,
  pageTitles,
  errors
} from './common'
import { auth, register, verifyEmail } from './auth'
import { landing, cookieConsent, abuse, kubernetes, vserver, vserverCompare, objectStorage, emailHosting, productsOverview, webhosting, comingSoon, pricingCalculator } from './landing'
import { sla, nis2Policy, termsPage, imprint, privacy, cancellation, withdrawal } from './legal'
import { termsArchive, termsChanges } from './termsArchive'
import { domains, domain, tldCatalog, cart, forms } from './products'
import { blog } from './blog'
import dashboard from './dashboard'
import { webmail } from './webmail'
import { oauth } from './oauth'

export default {
  common: { ...common, pageTitles },
  help,
  keyboard,
  password,
  notifications,
  breadcrumbs,
  quickActions,
  globalSearch,
  ticket,
  a11y,
  register,
  verifyEmail,
  validation,
  errors,
  auth,
  landing,
  cookieConsent,
  abuse,
  sla,
  kubernetes,
  vserver,
  vserverCompare,
  objectStorage,
  emailHosting,
  domains,
  domain,
  tldCatalog,
  cart,
  forms,
  productsOverview,
  webhosting,
  nis2Policy,
  termsPage,
  imprint,
  privacy,
  cancellation,
  withdrawal,
  termsArchive,
  termsChanges,
  pricingCalculator,
  comingSoon,
  blog,
  dashboard,
  webmail,
  oauth
} as const
